var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"role-page page-padding page-sidebar"},[_c('role-users-list'),_c('role-info',{on:{"reload":_vm.reloadRole}}),_c('p',{staticClass:"btn-hint name-hint btn-hint_bottom btn-hint-navigator"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }